// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__-XYDF","title":"Info_title__3qwGA","selects":"Info_selects__Iv2rG","requiredAsterisk":"Info_requiredAsterisk__3T1w_"};